import { Expose } from "class-transformer";
import { IsString } from "class-validator";

export default class DeleteProfile {
  @IsString()
  @Expose({ name: 'profile_id' })
  readonly profileId: string;

  @IsString()
  @Expose({ name: 'person_id' })
  readonly personId: string;

  constructor(init?: DeleteProfile) {
    this.personId = init?.personId!;
    this.profileId = init?.profileId!;
  }
}
